module.exports = "/images/instructors.ea7f848e5bcf839807ad51bcce2397b4.svg";